<script>
    export let isActive;
</script>

<style type="text/scss">
  * {
    transition: 250ms;
  }

  .inactive {
    margin: 16px;
    cursor: pointer;

    circle:nth-child(2) {
      fill: var(--white);
      stroke: var(--sapphire);
      r: 19;
    }

    path {
      fill: var(--sapphire);
    }

    &:hover {
      circle:nth-child(2) {
        fill: var(--yellow);
        stroke: var(--sapphire);
        r: 23;
      }
    }

    &:active {
      circle:nth-child(2) {
        fill: var(--sapphire);
        stroke: var(--sapphire);
        r: 23;
      }

      path {
        fill: var(--yellow);
      }
    }
  }
</style>

{#if isActive }
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
            <circle cx="40" cy="38" r="28" fill="#FFD436"/>
        </g>
        <path d="M39.1286 53.7307C39.3919 53.9063 39.7012 54 40.0176 54C40.334 54 40.6434 53.9063 40.9066 53.7307L55.3223 44.1202C55.5039 43.9996 55.6589 43.8432 55.7778 43.6605C55.8967 43.4779 55.977 43.2729 56.0137 43.058C56.0505 42.8432 56.0429 42.6231 55.9915 42.4114C55.9401 42.1996 55.8459 42.0005 55.7148 41.8265L41.299 22.6055C40.6952 21.7982 39.3401 21.7982 38.7362 22.6055L24.3205 41.8265C24.1898 42.0007 24.096 42.1997 24.0448 42.4115C23.9937 42.6232 23.9862 42.8431 24.0229 43.0578C24.0597 43.2725 24.1398 43.4774 24.2584 43.6601C24.3771 43.8427 24.5317 43.9993 24.7129 44.1202L39.1286 53.7307ZM52.1349 42.3935L40.0176 50.4727V26.2366L52.1349 42.3935Z"
              fill="#082567"/>
        <defs>
            <filter id="filter0_d" x="0" y="0" width="80" height="80" filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="6"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.95 0 0 0 0 0.773017 0 0 0 0 0.122708 0 0 0 0.4 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
            </filter>
        </defs>
    </svg>
{:else }
    <svg class="inactive" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="white"/>
        <circle cx="24" cy="24" r="19" fill="white" stroke="#082567" stroke-width="2"/>
        <path d="M22.8737 34.8064C23.0629 34.9326 23.2852 35 23.5127 35C23.7401 35 23.9624 34.9326 24.1516 34.8064L34.5129 27.8989C34.6434 27.8122 34.7548 27.6998 34.8403 27.5685C34.9257 27.4372 34.9835 27.2899 35.0099 27.1355C35.0363 26.9811 35.0309 26.8229 34.9939 26.6707C34.9569 26.5184 34.8893 26.3754 34.795 26.2503L24.4337 12.4352C23.9996 11.8549 23.0257 11.8549 22.5917 12.4352L12.2303 26.2503C12.1364 26.3755 12.069 26.5186 12.0322 26.6707C11.9954 26.8229 11.9901 26.981 12.0165 27.1353C12.0429 27.2896 12.1005 27.4369 12.1857 27.5682C12.271 27.6995 12.3822 27.812 12.5124 27.8989L22.8737 34.8064ZM32.2219 26.6578L23.5127 32.4648V15.0451L32.2219 26.6578Z"
              fill="#082567"/>
    </svg>
{/if}
